/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { PhotonBeamQualityDto } from './PhotonBeamQualityDto';
import {
    PhotonBeamQualityDtoFromJSON,
    PhotonBeamQualityDtoFromJSONTyped,
    PhotonBeamQualityDtoToJSON,
} from './PhotonBeamQualityDto';

/**
 * 
 * @export
 * @interface PhotonBeamQualitiesDto
 */
export interface PhotonBeamQualitiesDto {
    /**
     * 
     * @type {Array<PhotonBeamQualityDto>}
     * @memberof PhotonBeamQualitiesDto
     */
    values?: Array<PhotonBeamQualityDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PhotonBeamQualitiesDto
     */
    visible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualitiesDto
     */
    radiationTypeLabel: string;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualitiesDto
     */
    energyLabel: string;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualitiesDto
     */
    highDoseTechniqueTypeLabel: string;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualitiesDto
     */
    primaryFluenceShapingLabel: string;
    /**
     * 
     * @type {string}
     * @memberof PhotonBeamQualitiesDto
     */
    $type?: PhotonBeamQualitiesDtoTypeEnum;
}


/**
 * @export
 */
export const PhotonBeamQualitiesDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoTreatmentMachinesConfigurationPhotonBeamQualitiesDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.PhotonBeamQualitiesDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PhotonBeamQualitiesDtoTypeEnum = typeof PhotonBeamQualitiesDtoTypeEnum[keyof typeof PhotonBeamQualitiesDtoTypeEnum];



/**
 * Check if a given object implements the PhotonBeamQualitiesDto interface.
 */
export function instanceOfPhotonBeamQualitiesDto(value?: unknown): value is PhotonBeamQualitiesDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PhotonBeamQualitiesDtoTypeEnum)[0];
}

export function PhotonBeamQualitiesDtoFromJSON(json: any): PhotonBeamQualitiesDto {
    return PhotonBeamQualitiesDtoFromJSONTyped(json, false);
}

export function PhotonBeamQualitiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhotonBeamQualitiesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'values': json['values'] == null ? undefined : ((json['values'] as Array<any>).map(PhotonBeamQualityDtoFromJSON)),
        'visible': json['visible'] == null ? undefined : json['visible'],
        'radiationTypeLabel': json['radiationTypeLabel'],
        'energyLabel': json['energyLabel'],
        'highDoseTechniqueTypeLabel': json['highDoseTechniqueTypeLabel'],
        'primaryFluenceShapingLabel': json['primaryFluenceShapingLabel'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PhotonBeamQualitiesDtoToJSON(value?: PhotonBeamQualitiesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'values': value['values'] == null ? undefined : ((value['values'] as Array<any>).map(PhotonBeamQualityDtoToJSON)),
        'visible': value['visible'],
        'radiationTypeLabel': value['radiationTypeLabel'],
        'energyLabel': value['energyLabel'],
        'highDoseTechniqueTypeLabel': value['highDoseTechniqueTypeLabel'],
        'primaryFluenceShapingLabel': value['primaryFluenceShapingLabel'],
        '$type': value['$type'],
    });
}

